/** The fraction a variant stands for: «½», «¼»; the whole one has no word. */
export function variantText(priceAmount: number): string {
  if (priceAmount === 1) {
    return '';
  }
  const known: Record<string, string> = { '0.5': '½', '0.25': '¼', '0.75': '¾', '0.33': '⅓', '0.67': '⅔' };
  return known[String(priceAmount)] ?? String(priceAmount);
}

/**
 * The weight of the VARIANT a line holds, in grams: the server gives the weight of the product (a whole cake, 1200 g), and a half of it weighs half — `weight × priceAmount`, to the gram. A line
 * that has no weight (a delivery, a service, a product the server did not weigh) has none.
 */
export function lineWeight(line: { weight?: number; priceAmount: number }): number | undefined {
  return line.weight !== undefined && line.weight > 0 ? Math.round(line.weight * line.priceAmount) : undefined;
}
